import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";

function PageNotFound() {
  return (
    <div>
      {/*Add title and metadata */}
      <title>Change Password</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />
      {/* Verify Email body */}
      <div className="p-3">
        <div
          className="container col-md-4 col-md-offset-4"
          style={{ marginTop: "8rem" }}
        >
          <h1 className="display-3 text-center">404 Page Not Found</h1>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default PageNotFound;
